















































































import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import studentEduInfoRowsBlocks from '@/components/Students/Page/studentEduInfoRowsBlocks.vue'
export default Vue.extend({
  props: {
    scope: {},
    options: {}
  },
  components: {
    infoRowsBlock,
    studentEduInfoRowsBlocks
  },
  computed: {
    cards () {
      // @ts-ignore
      return this.scope.student.getCards();
    }
  }
})
